import styled from 'styled-components';
import { mediaQueries } from '../shared/config';

const Container = styled.div`
  width: 70vh;
  height: 40vh;
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  cursor: pointer;
  border: 1px solid white;

  &:hover .content {
    opacity: 1;
    visibility: visible;
  }

  &:hover .image {
    opacity: 0.5;
  }

  ${mediaQueries.mobile} {
    width: 35vh;
    height: 20vh;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  transition: opacity 0.3s, visibility 0.3s;
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.75);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5em;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
  padding: 4vh;

  &:hover {
    opacity: 1;
    visibility: visible;
  }
`;

const Title = styled.div`
  font-family: "Playfair Display", serif;
  font-weight: 400;
  font-size: 3.2vh;
  text-align: left;
  color: #9E7EC7;
  padding-right: 2em;
  flex: 1;
  margin-top: 0.5em;

  ${mediaQueries.mobile} {
    font-size: 1.5vh;
    padding-right: 3em;
  }
`;

const ByLine = styled.div`
  font-family: "Work Sans", sans-serif;
  font-weight: 400;
  font-size: 2.2vh;
  text-transform: uppercase;
  text-align: left;
  color: #9E7EC7;
  padding-right: 2em;
  flex: 1;

  ${mediaQueries.mobile} {
    font-size: 1vh;
    padding-right: 3em;
    margin-top: -7em;
  }
`;

const Image2 = styled.img`
  width: 100%;
  height: auto;
  position: absolute;
  top: -35%; /* Adjust this value to shift the image upwards */
  left: 50%;
  transform: translateX(-50%);
  object-fit: cover;
`;

const ArticleCard = (props) => {
  const { article_image, article_title, article_byline, article_url, ten } = props;

  return (
    <a href={article_url} style={{ textDecoration: 'none' }}>
      <Container>
        {ten === "false" ? (
          <>
            <Image src={article_image} className="image" alt="Article" />
            <Content className="content">
              <Title>{article_title}</Title>
              <ByLine>{article_byline}</ByLine>
            </Content>
          </>
        ) : (
          <>
            <Image2 src={article_image} className="image" alt="Article" top="-50%" />
            <Content className="content">
              <Title>{article_title}</Title>
              <ByLine>{article_byline}</ByLine>
            </Content>
          </>
        )}
      </Container>
    </a>
  );
}

export default ArticleCard;
